<template>
    <b-modal
        size="lg"
        title="New Survey"
        ref="NewSurvey"
        @hidden="closeModal">
        <div id="new-survey" class="modal-form">
            <b-row no-gutters>
                <b-col sm="12" md="2">
                    <h6 class="main-label">Survey</h6>
                </b-col>
                <b-col>
                    <b-form-group id="titleGroup"
                        label="Title"
                        label-for="title"
                        class="secondary-label mb-3 sl-helper"
                        :invalid-feedback="errorMessage('title')"
                        :state="isValid('title')">
                        <b-form-input id="title"
                            type="text"
                            required
                            v-model="survey.title">
                        </b-form-input>
                    </b-form-group>
                    <b-form-group id="descGroup"
                        label="Description"
                        label-for="description"
                        class="secondary-label mb-3 sl-helper"
                        :invalid-feedback="errorMessage('description')"
                        :state="isValid('description')">
                        <b-form-textarea id="description"
                            rows="3"
                            max-rows="6"
                            v-model="survey.description">
                        </b-form-textarea>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col>
                    <hr class="form-divider">
                </b-col>
            </b-row>
            <b-row no-gutters>
                <b-col sm="12" md="2">
                    <h6 class="main-label">Display</h6>
                </b-col>
                <b-col>
                    <b-form-group id="segmentGroup"
                        label="Target Segment"
                        label-for="targetsegment"
                        class="secondary-label mb-3 sl-helper"
                        :invalid-feedback="errorMessage('target_segment_uuid')"
                        :state="isValid('target_segment_uuid')">
                        <b-form-select id="targetsegment"
                            :options="survey.target_segments"
                            v-model="survey.selectedSegment">
                        </b-form-select>
                    </b-form-group>
                    <b-row no-gutters>
                        <b-col md="8">
                            <b-form-group id="startdateGroup"
                                label="Start Date"
                                label-for="start_date"
                                class="secondary-label mb-3 sl-helper"
                                :invalid-feedback="errorMessage('start_date')"
                                :state="isValid('start_date')">
                                <b-input-group class="custom-datepicker mb-3 muli-sb d-flex">
                                    <b-input-group-text slot="append" class="bg-transparent">
                                        <img src="../../../assets/images/icons/calendar.svg" alt="Calendar Icon" class="form-icon action-button"
                                            @click="openCalendar('start')">
                                    </b-input-group-text>
                                    <SingleDatepicker :bootstrap-styling="true"
                                        :value="survey.start_date"
                                        ref="datepicker_start"
                                        v-model="survey.start_date"
                                        wrapper-class="custom-datepicker"
                                        style="color: #2a2a2a !important;"
                                        :disabledDates="disabledDates"
                                    />
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col md="4">
                            <b-form-group
                                label="Start Time"
                                label-for="start_time"
                                class="secondary-label mb-3 sl-helper">
                                <div id="custom-timepicker" style="width: 164px;">
                                    <b-input-group>
                                        <b-input-group-text slot="append" class="bg-transparent">
                                            <img src="../../../assets/images/icons/time.svg" alt="Time Icon" class="form-icon action-button">
                                        </b-input-group-text>
                                        <vue-timepicker
                                            format="HH:mm"
                                            hide-clear-button
                                            v-model="survey.start_time">
                                        </vue-timepicker>
                                    </b-input-group>
                                </div>
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <b-row no-gutters>
                        <b-col md="7">
                            <b-form-group id="enddateGroup"
                                label="End Date"
                                label-for="end_date"
                                class="secondary-label mb-3 sl-helper"
                                :invalid-feedback="errorMessage('end_date')"
                                :state="isValid('end_date')">
                                <b-input-group class="custom-datepicker mb-3 muli-sb d-flex">
                                    <b-input-group-text slot="append" class="bg-transparent">
                                        <img src="../../../assets/images/icons/calendar.svg" alt="Calendar Icon" class="form-icon action-button"
                                            @click="openCalendar('end')" >
                                    </b-input-group-text>
                                    <SingleDatepicker :bootstrap-styling="true"
                                        :value="survey.end_date"
                                        ref="datepicker_end"
                                        v-model="survey.end_date"
                                        wrapper-class="custom-datepicker flex-grow-1"
                                        style="color: #2a2a2a !important;"
                                        :disabledDates="disabledDates"
                                    />
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col md="4" offset="1">
                            <b-form-group
                                label="End Time"
                                label-for="end"
                                class="secondary-label mb-3 sl-helper">
                                <div id="custom-timepicker" style="width: 164px;">
                                    <b-input-group>
                                        <b-input-group-text slot="append" class="bg-transparent">
                                            <img src="../../../assets/images/icons/time.svg" alt="Time Icon" class="form-icon action-button">
                                        </b-input-group-text>
                                        <vue-timepicker
                                            format="HH:mm"
                                            hide-clear-button
                                            v-model="survey.end_time">
                                        </vue-timepicker>
                                    </b-input-group>
                                </div>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    
                    <b-form-group
                        label="Display no. of times user can cancel"
                        label-for="cancel_limit"
                        class="secondary-label mb-3 sl-helper"
                        :invalid-feedback="errorMessage('attempts')"
                        :state="isValid('attempts')">
                        <b-col md="2" class="px-0">
                            <b-form-input type="number" min="1" v-model="survey.cancel_limit"
                                @keyup.native="checkCancelLimit()"
                                @change="supplyCancelLimit()"></b-form-input>
                        </b-col>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col>
                    <hr class="form-divider">
                </b-col>
            </b-row>
            <b-row no-gutters>
                <b-col sm="12" md="2">
                    <h6 class="main-label">Questions</h6>
                </b-col>
                <b-col>
                    
                        <Question
                            v-for="(question, index) in survey.questions"
                            :label="'Question ' + (index + 1)"
                            :labelFor="'question' + index"
                            :model="survey.questions[index].question"
                            :key="index"
                            :index="index"
                            @saveModel="storeModel"
                            @deleteModel="deleteModel"
                            :selected="survey.questions[index].selected" />

                    <template v-if="survey.questions.length < 10">

                        <button type="button" class="btn btn-ghost text-primary shadow-none px-0 mt-2 mb-3"
                            @click="addQuestion">
                            <img src="../../../assets/images/icons/add.svg" alt="add" class="mr-2"> Add a Question
                        </button>
                        
                    </template>
                </b-col>
            </b-row>
        </div>
        <div slot="modal-footer">
            <b-button
                variant="ghost"
                class="btn-cancel"
                style="margin-right: .25rem;"
                @click="closeModal">
                Cancel
            </b-button>
            <b-button
                variant="primary"
                style="margin-left: .25rem;"
                @click="saveSurvey">
                Save
            </b-button>
        </div>
    </b-modal>
</template>

<script>
import SingleDatepicker from "vuejs-datepicker";
import Question from "./Question";
import VueTimepicker from "vue2-timepicker";

import { mapState } from "vuex";

export default {
    name: "NewSurvey",
    props: ["open"],
    components: {
        SingleDatepicker,
        Question,
        VueTimepicker
    },
    data() {
        return {
            survey: {
                title: "",
                description: "",
                selectedSegment: "default",
                target_segments: [{ value: "default", text: "All Customers" }],
                start_date: new Date(),
                start_time: {
                    HH: new Date().getHours(),
                    mm: this.transformMinutes(new Date().getMinutes())
                },
                end_date: new Date(),
                end_time: {
                    HH: new Date().getHours(),
                    mm: this.transformMinutes(new Date().getMinutes())
                },
                cancel_limit: 1,
                questions: [
                    { question: "", has_ratings: 0, has_textfield: 0 }
                ]
            },
            disabledDates: {
                to: new Date(Date.now() - 8640000)
            }
        };
    },
    computed: {
        ...mapState("engagementSurvey", ["targetSegments", "param", "errors"])
    },
    created: function() {
        this.getTargetSegments();
    },
    methods: {
        setFormInit: async function() {
            this.survey["title"] = "";
            this.survey["description"] = "";
            this.survey["selectedSegment"] = null;
            this.survey["start_date"] = new Date();
            this.survey["end_date"] = new Date();
            this.survey["cancel_limit"] = 0;
            this.survey["questions"] = [];
        },

        closeModal: async function() {
            await this.setFormInit();
            await this.$store.commit("engagementSurvey/setModal", {
                type: "new",
                status: false
            });
            this.survey["questions"].push({ question: "", has_ratings: 0, has_textfield: 0 });
            this.$store.commit("engagementSurvey/clearErrors");
        },

        openCalendar(type) {
            let calendar = "datepicker_" + type;
            this.$refs[calendar].showCalendar();
        },

        addQuestion: function() {
            if(this.survey.questions.length < 10) {
                this.survey.questions.push({ question: "", has_ratings: 0, has_textfield: 0 });
            }
        },

        storeModel: function(value) {
            let selected = value.selected ? value.selected : [];
            this.survey.questions[value.index].question = value.question;
            this.survey.questions[value.index].selected = value.selected;
            if (selected.length > 0) {
                this.survey.questions[value.index].has_ratings = Object.values(selected).includes("ratings") ? 1 : 0;
                this.survey.questions[value.index].has_textfield = Object.values(selected).includes("textfield") ? 1 : 0;
            } else {
                this.survey.questions[value.index].has_ratings = 0;
                this.survey.questions[value.index].has_textfield = 0;
            }
        },

        saveSurvey: async function() {
            let param = {
                title: this.survey.title,
                description: this.survey.description,
                target_segment_uuid: this.survey.selectedSegment,
                attempts: this.survey.cancel_limit,
                start_date: await this.tranformDateTime(this.$moment(this.survey.start_date), "start"),
                end_date: await this.tranformDateTime(this.$moment(this.survey.end_date), "end"),
                is_enabled: true,
                questions: await this.simplifyQuestions(this.survey.questions)
            };

            // console.log({
            //     param: param
            // });

            let _this = this;

            await this.$store.dispatch("engagementSurvey/create", param)
                .then(() => {
                    if (this.errors == null) {
                        this.$store.dispatch("engagementSurvey/getList", this.param);
                    }
                });
        },

        deleteModel: async function(question) {
            
            if(this.errors !== null) {
                await this.$store.commit("engagementSurvey/clearErrors");
            }

            this.survey.questions.splice(question.index, 1);
        },

        getTargetSegments: async function() {
            let _this = this;
            await this.$store.dispatch("engagementSurvey/getTargetSegments")
                .then(async function() {
                    let valid_targets = _this.targetSegments;

                    if (valid_targets !== null) {
                        for (var i=0; valid_targets.length>i; i++) {
                            await _this.survey.target_segments.push(valid_targets[i]);
                        }
                    }
                });
        },

        transformMinutes: function(minutes) {
            if (minutes < 10) {
                minutes = "0" + minutes;
            }
            return minutes;
        },

        tranformDateTime: function(datetime, type) {
            let hh = this.survey[type + "_time"].HH;
            let mm = this.survey[type + "_time"].mm;
            return datetime.format("YYYY-MM-DD") + " " + hh + ":" + mm;
        },

        simplifyQuestions: function(questions) {
            let cleaned_questions = [];
            for (var i=0; questions.length>i; i++) {
                let question = {
                    question: questions[i].question,
                    has_ratings: questions[i].has_ratings === 0 &&
                        questions[i].has_textfield === 0
                        ? ""
                        : questions[i].has_ratings,
                    has_textfield: questions[i].has_textfield === 0 &&
                        questions[i].has_ratings === 0
                        ? ""
                        : questions[i].has_textfield
                }
                cleaned_questions.push(question);
            }
            return cleaned_questions;
        },

        errorMessage(field) {
            if (this.errors == null) {
                return "";
            }
            
            return this.errors[field];
        },

        isValid(field) {
            if (this.errors == null) {
                return false;
            }
            
            return this.errors[field] ? false : true;
        },

        checkCancelLimit: function(evt) {
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            let this_value = evt.target.value;
            if (charCode != 8) {
                if (this_value == null || this_value == 0) {
                    this.survey.cancel_limit = 1;
                } else if (this_value.length > 2) {
                    this.survey.cancel_limit = this_value.slice(0, 2);
                }
            }
        },

        supplyCancelLimit: function() {
            if (this.survey.cancel_limit == null || this.survey.cancel_limit == 0) {
                this.survey.cancel_limit = 1;
            } else if (this.survey.cancel_limit.length > 2) {
                this.survey.cancel_limit = this_value.slice(0, 2);
            }
        }
    },
    watch: {
        open: async function(value) {
            if(value === true) {
                this.$refs.NewSurvey.show();
            } else {
                this.$refs.NewSurvey.hide();
            }
        }
    }
}
</script>
